module.exports = __webpack_public_path__ + "img/shipping.29e0990e.svg";